import { create } from 'zustand';
import type { User } from '@shared/types';
import { identifyUser, resetUser } from '@/lib/posthog';

interface AuthStore {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setLoading: (isLoading: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  setUser: (user) => {
    console.log('[AUTH STORE] setUser called', {
      user: user ? { id: user.id, email: user.email } : null,
      isAuthenticated: !!user,
      isLoading: false
    });

    // Identify user in PostHog for analytics
    if (user) {
      identifyUser({
        id: user.id,
        email: user.email,
        fullName: user.fullName,
        role: user.role,
        isSuperAdmin: user.isSuperAdmin,
      });
    }

    set({
      user,
      isAuthenticated: !!user,
      isLoading: false,
    });
  },
  setLoading: (isLoading) => {
    console.log('[AUTH STORE] setLoading called', { isLoading });
    set({ isLoading });
  },
  logout: () => {
    console.log('[AUTH STORE] logout called');
    // Reset PostHog user identity
    resetUser();
    set({
      user: null,
      isAuthenticated: false,
      isLoading: false,
    });
  },
}));
